export enum ERestMethod {
  Get = 'GET',
  Put = 'PUT',
  Delete = 'DELETE',
  Post = 'POST',
  Patch = 'PATCH',
}
